<template>
  <div>
    <v-tabs v-model="tabItemActive"
            dark
            max="500"
            color="grey"
            class="tab-style mt-default"
            show-arrows
            icons-and-text
            hide-slider>

      <v-tabs-slider color="yellow"></v-tabs-slider>

      <template v-for="(item) in tabList">
        <v-tab v-show="item.show"
               :href="'#' + item.step"
               :key="item.step"
               :disabled="item.disabled"
               :class="{'tab-done':item.done}"
               @click="tabChange(item)">
          <div>{{item.name}}{{showValidateNum(item.step)}}</div>
          <tab-icon :step="item.iconCode"></tab-icon>
          <v-icon class="tab-done-icon"
                  v-show="item.done">done</v-icon>
        </v-tab>
      </template>
    </v-tabs>

    <router-view ref="refTabItem"
                 @forceClose="forceClose"
                 @go-top="$emit('go-top')"
                 @set-trans-code="setTransCode"
                 @set-tab-show="setTabShow"
                 @set-tab-done="setTabDone"
                 @temp-btn-hide="tempBtnHide"
                 @set-validate-num="setValidateNum"
                 @update-type-o-status="updateTypeOStatus"
                 @update-type-i-status="updateTypeIStatus"
                 @update-legal-status="updateLegalStatus"
                 @update-cus-type-o-ref-address="updateCusTypeORefAddress"
                 @update-cus-type-i-ref-address="updateCusTypeIRefAddress"
                 @update-cus-type-o-address-status="updateCusTypeOAddressStatus"
                 @update-cus-type-i-address-status="updateCusTypeIAddressStatus"></router-view>
  </div>
</template>

<script>
import TabIcon from '@/components/Base/SvgIcon/TabIcon'
import ProposalStepsBase from './ProposalStepsBase'
const isDev = process.env.NODE_ENV === 'development'
export default {

  extends: ProposalStepsBase,

  components: {
    TabIcon
  },

  props: {
    routerPage: { // 指定要去的頁面
      type: String,
    },
  },

  data () {
    return {
      tabItemActive: null, // 當下亮燈tab
    }
  },

  mounted () {
    const compList = this.$store.getters['common/proCompanies']({
      channelCode: 'FIN',
      compCode: [this.compCode]
    })
    let title = ''
    if (compList && compList[0]) {
      title = '要保書建置-' + compList[0].compName + '(行動投保)'
      //title = '要保書建置-行動投保'
    } else {
      title = '要保書建置'
    }
    this.$emit('set-title', title)
  },

  computed: {
    isEditLock () {
      return this.$store.getters['common/isEditLock']
    }
  },

  watch: {
    tabStep (v) {
      this.tabItemActive = v //從上一步下一步異動的tabStep來改變亮燈tabItemActive
    }
  },

  beforeRouteEnter (to, from, next) {
    const { compCode } = to.params
    next(vm => {
      vm.init (compCode)
    })
  },

  methods: {
    init (compCode) {
      if(!compCode) compCode= 'CH'
      this.compCode = compCode

      let tabList = [
          {name: '要保人',     iconCode: "1", disabled: false, show: true, done: false, rt: 'INS_S1', step: 'n1', nextStep: 'n2', preStep: '', validateNum: 0},
          {name: '被保險人',     iconCode: "2", disabled: false, show: true, done: false, rt: 'INS_S2', step: 'n2', nextStep: 'n3', preStep: 'n1', validateNum: 0},
          {name: '法定代理人',   iconCode: "3", disabled: false, show: true, done: false, rt: 'INS_S3', step: 'n3', nextStep: 'n4', preStep: 'n2', validateNum: 0},
          {name: '檢核項目',     iconCode: "4", disabled: false, show: true, done: false, rt: 'INS_S4', step: 'n4', nextStep: 'n5', preStep: 'n3', validateNum: 0},
          {name: '附件上傳',     iconCode: "5", disabled: false, show: true, done: false, rt: 'INS_S5', step: 'n5', nextStep: 'n6', preStep: 'n4', validateNum: 0},
          {name: '其他聲明事項', iconCode: "6", disabled: false, show: true, done: false, rt: 'INS_S6', step: 'n6', nextStep: 'n7', preStep: 'n5', validateNum: 0},
          {name: '書面分析資料', iconCode: "7", disabled: false, show: true, done: false, rt: 'INS_S7', step: 'n7', nextStep: 'n8', preStep: 'n6', validateNum: 0},
          {name: '簽名資料',     iconCode: "8", disabled: false, show: true, done: false, rt: 'INS_S8', step: 'n8', nextStep: 'n9', preStep: 'n7', validateNum: 0},
          {name: '保經表單',     iconCode: "9", disabled: false, show: true, done: false, rt: 'INS_S9', step: 'n9', nextStep: 'none', preStep: 'n8', validateNum: 0}
      ]
      this.tabList = [...tabList]

      if (this.routerPage) { // 進入指定頁面
        this.tabList[0].show = false
        this.tabList[1].show = false
        this.tabList[2].show = false
        this.tabList[3].show = false
        this.tabList[4].show = false
        this.tabList[5].show = false
        this.tabList[6].show = false
        this.tabList[7].show = false

        let item = this.tabList.find(obj => {
          return obj.rt === this.routerPage
        })
        let preStep = item.preStep
        // 進入指定頁面step之前的設成disabled
        while (item.preStep) {
          let tab = this.tabList.find(obj => {
            return obj.step === preStep
          })
          if (tab) {
            if (isDev) {
              tab.disabled = false
            } else {
              tab.disabled = true
            }
            tab.done = true
            preStep = tab.preStep
          } else {
            break
          }
        }
        this.tabItemActive = item.step
        this.routerReplace(item, null)
      } else {
        //this.tabList[6].show = false
        //this.tabList[7].show = false
        this.tabList[8].show = false

        this.tabItemActive = 'n1' // 預設第一步亮燈
        this.routerReplace(this.tabList[0], null)

      }
    },
    tempSave () {
      const tabRef = this.$refs['refTabItem']
      tabRef && tabRef.tempSave && tabRef.tempSave()
    },
    close () {
      this.$confirm('是否確認離開此要保書建置？').then(yn => {
        if (yn) {
          const progClassName = `QuitInsS${this.tabStep}`
          this.$postUserAccessLog({ progClassName, methodName: '退出', stepCode: this.tabStep, transCode: this.transCode })
          this.$router.replace({ name: 'proposal' })
        }
      })
    },
    forceClose () {
      this.$router.replace({ name: 'proposal' })
    },
    setTransCode (transCode, callback) {
      this.transCode = transCode
      callback && callback()
    },
    setTabShow ({step, flag}) {
      this.$setTabShow(step, flag)
    },
    setTabDone ({step, flag}) {
      this.$setTabDone(step, flag)
    },
    tabChange (item) {
      if(item.step === 'n4') { // 進入檢核項目頁面(呼叫電文)
        this.fetchCheckItem({ transCode: this.transCode, isPreview: this.isPreview, fromSearch: false }).then(r => {
          if (r.data.errorMsg != null ) { // 不通過要顯示訊息
            this.tabItemActive = this.tabStep // tab亮燈停留在當下頁面
              this.$alert(r.data.errorMsg )
            } else {
              this.routerReplace(item, r.data) // 帶prop 參數與電文檢核後的資料做rouer導頁
            }
          })
        } else {
          this.routerReplace(item, null)  // 帶prop 參數做rouer導頁
        }
    },
    routerReplace(item, checkItemObject) {
      if (item.show && !item.disabled && this.tabStep !== item.step) {
        const { propKey, transCode, compCode } = this
        propKey.transCode = transCode
        propKey.compCode = compCode
        propKey.cusTypeOCheck = this.cusTypeOCheck
        propKey.cusTypeICheck = this.cusTypeICheck
        propKey.policyLegAgent = this.policyLegAgent
        propKey.insuredLegAgent = this.insuredLegAgent
        propKey.cusTypeORefAddressR = this.cusTypeORefAddressR
        propKey.cusTypeORefAddress = this.cusTypeORefAddress
        propKey.cusTypeIRefAddressR = this.cusTypeORefAddress
        propKey.cusTypeIRefAddress = this.cusTypeORefAddress
        propKey.cusTypeOAddressRCheck = this.cusTypeOAddressRCheck
        propKey.cusTypeOAddressCheck = this.cusTypeOAddressCheck
        propKey.cusTypeIAddressRCheck = this.cusTypeIAddressRCheck
        propKey.cusTypeIAddressCheck = this.cusTypeIAddressCheck
        propKey.checkItemObject = checkItemObject

        const progClassName = `GoInsS${item.step}`
        this.$postUserAccessLog({ progClassName, methodName: '跳頁籤', stepCode: item.step, transCode })
        let params = { ...this.$props, tabListProp: this.tabList, tabStepProp: item.step, propKey: propKey }
        this.$emit('temp-btn-hide',item.step, this.isPreview)
        this.tabItemActive = item.step // 要前往的tab亮燈
        this.$router.replace({ name: item.rt, params })
      }
    },
    setValidateNum ({ step, num }) {
      let item = this.tabList.find(obj => {
        return obj.step === step
      })
      if (item) {
        item.validateNum = num
      }
    },
    getValidateNum (step) {
      let item = this.tabList.find(obj => {
        return obj.step === step
      })
      if (item) {
        return item.validateNum
      }
    },
    showValidateNum (step) {
      let num = this.getValidateNum(step)
      if (num > 0 && num !== 8) {
        return '(' + num + ')'
      }
      return ''
    },
    updateTypeOStatus (val) {
      this.cusTypeOCheck = val
    },
    updateTypeIStatus (val) {
      this.cusTypeICheck = val
    },
    updateLegalStatus ({typeCode}) {
      if (typeCode === 'O') {
        this.policyLegAgent = 'Y'
      } else if (typeCode === 'I') {
        this.insuredLegAgent = 'Y'
      } else if (typeCode === 'ALL') {
        this.policyLegAgent = 'N'
        this.insuredLegAgent = 'N'
      }
    },
    updateCusTypeORefAddress ({cusTypeORefAddressR, cusTypeORefAddress}) {
      this.cusTypeORefAddressR = cusTypeORefAddressR
      this.cusTypeORefAddress = cusTypeORefAddress
    },
    updateCusTypeIRefAddress ({cusTypeIRefAddressR, cusTypeIRefAddress}) {
      this.cusTypeIRefAddressR = cusTypeIRefAddressR
      this.cusTypeIRefAddress = cusTypeIRefAddress
    },
    updateCusTypeOAddressStatus ({cusTypeOAddressRCheck, cusTypeOAddressCheck}) {
      this.cusTypeOAddressRCheck = cusTypeOAddressRCheck
      this.cusTypeOAddressCheck = cusTypeOAddressCheck
    },
    updateCusTypeIAddressStatus ({cusTypeIAddressRCheck, cusTypeIAddressCheck}) {
      this.cusTypeIAddressRCheck = cusTypeIAddressRCheck
      this.cusTypeIAddressCheck = cusTypeIAddressCheck
    },
    tempBtnHide(step,isPreview) { // 排除特定頁籤步顯示暫存按鈕
      this.$emit('temp-btn-hide',step, isPreview)
    }
  }

}
</script>
